import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  listJoinRequests, approveJoinRequest, rejectJoinRequest,
  listVerifyRequests, approveVerifyRequest, rejectVerifyRequest,
  listStaff,
} from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

const norm = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

// Danh sách chờ xác thực — người dùng tham gia trường nhưng không khớp hồ sơ,
// VÀ người đã có tài khoản nhưng nhập thông tin xác thực không khớp hồ sơ.
const HappySchoolJoinRequests = () => {
  const schoolId = getActiveSchoolId();
  const [rows, setRows] = useState([]);
  const [vrows, setVrows] = useState([]);
  const [allStaff, setAllStaff] = useState([]); // để chọn "gắn vào hồ sơ có sẵn" thay vì luôn tạo mới
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");
  const [roleChoice, setRoleChoice] = useState({}); // uid -> "teacher" | "staff", chỉ dùng khi TẠO MỚI
  const [linkChoice, setLinkChoice] = useState({}); // uid -> "" (tạo mới) | staffId (gắn vào hồ sơ có sẵn)
  const [expandedV, setExpandedV] = useState(null); // uid đang mở bảng "xem lệch chỗ nào"

  const reload = () => {
    if (!schoolId) return;
    setLoading(true);
    Promise.all([listJoinRequests(schoolId), listVerifyRequests(schoolId), listStaff(schoolId)])
      .then(([list, vlist, staffList]) => {
        setRows((list || []).sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)));
        setVrows((vlist || []).sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)));
        setAllStaff((staffList || []).slice().sort((a, b) => a.name.localeCompare(b.name, "vi")));
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };
  useEffect(reload, [schoolId]);

  // staffId dạng "<slug>__<key>" -> suy ra role cho schoolMembers khi GẮN vào
  // hồ sơ có sẵn (khác "department" chỉ dùng lúc TẠO MỚI).
  const roleForStaffId = (staffId) => {
    const slug = String(staffId).split("__")[0];
    return slug === "giao-vien-thpt" || slug === "nghe" ? "teacher" : "staff";
  };

  const roleLabel = (r) => (r === "student" ? "Học sinh" : "Giáo viên / Nhân sự");
  // Duyệt tay sẽ tự tạo hồ sơ trong "Nhân sự toàn trường" đúng Khối tương ứng.
  const ROLE_CHOICES = {
    "teacher-vh": { role: "teacher", department: "giao-vien-thpt", label: "Giáo viên VH" },
    "teacher-nghe": { role: "teacher", department: "nghe", label: "Giáo viên Nghề" },
    staff: { role: "staff", department: "phong-hanh-chinh", label: "Nhân sự (không giảng dạy)" },
  };

  const approve = async (uid, requestRole) => {
    setBusy(uid);
    try {
      if (requestRole === "student") {
        await approveJoinRequest(schoolId, uid, { role: "student" });
      } else if (linkChoice[uid]) {
        // Gắn vào hồ sơ nhân sự ĐÃ CÓ SẴN (vd trùng tên với hồ sơ đang dùng
        // để xếp TKB) — không tạo hồ sơ mới, tránh trùng 2 hồ sơ cùng tên.
        await approveJoinRequest(schoolId, uid, { role: roleForStaffId(linkChoice[uid]), staffId: linkChoice[uid] });
      } else {
        const choice = ROLE_CHOICES[roleChoice[uid] || "teacher-vh"];
        await approveJoinRequest(schoolId, uid, { role: choice.role, department: choice.department });
      }
      reload();
    } catch (e) { setError(e.message); } finally { setBusy(""); }
  };
  const reject = async (uid) => {
    if (!window.confirm("Từ chối và xoá yêu cầu này?")) return;
    setBusy(uid);
    try { await rejectJoinRequest(schoolId, uid); reload(); }
    catch (e) { setError(e.message); } finally { setBusy(""); }
  };
  const approveV = async (uid) => {
    setBusy(uid);
    try { await approveVerifyRequest(schoolId, uid); reload(); }
    catch (e) { setError(e.message); } finally { setBusy(""); }
  };
  const rejectV = async (uid) => {
    if (!window.confirm("Từ chối yêu cầu xác thực này?")) return;
    setBusy(uid);
    try { await rejectVerifyRequest(schoolId, uid); reload(); }
    catch (e) { setError(e.message); } finally { setBusy(""); }
  };

  if (!schoolId) return <div style={{ padding: 24 }}>Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link>.</div>;

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 4px" }}>⏳ Chờ xác thực</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Những người đã tham gia trường nhưng chưa khớp hồ sơ (Họ tên + CCCD). Duyệt để cấp quyền, hoặc từ chối.
      </p>
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {loading ? <p>Đang tải...</p> : rows.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Không có yêu cầu nào đang chờ.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
          <thead><tr>
            <th style={th}>Họ và tên</th><th style={th}>CCCD / Lớp</th><th style={th}>Vai trò</th><th style={th}>Ngày gửi</th><th style={th}>Thao tác</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.uid}>
                <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.name}</td>
                <td style={td}>{r.cccd || (r.className ? `Lớp ${r.className}` : "")}</td>
                <td style={td}>
                  {r.role === "student" ? roleLabel(r.role) : (() => {
                    const sameName = allStaff.filter((s) => norm(s.name) === norm(r.name));
                    const others = allStaff.filter((s) => norm(s.name) !== norm(r.name));
                    return (
                      <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "stretch" }}>
                        <select
                          value={linkChoice[r.uid] || ""}
                          onChange={(e) => setLinkChoice((m) => ({ ...m, [r.uid]: e.target.value }))}
                          style={{ padding: 4, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12, background: linkChoice[r.uid] ? "#ecfdf5" : "#fff" }}
                          title="Gắn vào hồ sơ nhân sự đã có sẵn thay vì tạo hồ sơ mới trùng tên"
                        >
                          <option value="">➕ Tạo hồ sơ mới</option>
                          {sameName.length > 0 && (
                            <optgroup label="⚠ Trùng tên — có thể là cùng người">
                              {sameName.map((s) => (<option key={s.id} value={s.id}>{s.name} — {s.department}</option>))}
                            </optgroup>
                          )}
                          <optgroup label="Gắn vào hồ sơ khác">
                            {others.map((s) => (<option key={s.id} value={s.id}>{s.name} — {s.department}</option>))}
                          </optgroup>
                        </select>
                        {!linkChoice[r.uid] && (
                          <select
                            value={roleChoice[r.uid] || "teacher-vh"}
                            onChange={(e) => setRoleChoice((m) => ({ ...m, [r.uid]: e.target.value }))}
                            style={{ padding: 4, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12 }}
                          >
                            {Object.entries(ROLE_CHOICES).map(([key, c]) => (
                              <option key={key} value={key}>{c.label}</option>
                            ))}
                          </select>
                        )}
                      </div>
                    );
                  })()}
                </td>
                <td style={td}>{r.createdAt ? new Date(r.createdAt).toLocaleDateString("vi-VN") : ""}</td>
                <td style={td}>
                  <button disabled={busy === r.uid} onClick={() => approve(r.uid, r.role)} style={okBtn}>Duyệt</button>{" "}
                  <button disabled={busy === r.uid} onClick={() => reject(r.uid)} style={noBtn}>Từ chối</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <h2 style={{ margin: "28px 0 4px" }}>🔎 Xác thực lệch hồ sơ</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Tài khoản đã liên kết hồ sơ nhưng nhập Họ tên/CCCD/Ngày sinh không khớp dữ liệu đang lưu.
        Duyệt = cập nhật hồ sơ nhân sự theo đúng thông tin họ vừa nhập và đánh dấu đã xác thực.
      </p>
      {!loading && vrows.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Không có yêu cầu nào đang chờ.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
          <thead><tr>
            <th style={th}>Họ tên đã nhập</th><th style={th}>Ngày gửi</th><th style={th}>Thao tác</th>
          </tr></thead>
          <tbody>
            {vrows.map((r) => {
              const fields = [
                { label: "Họ và tên", cur: r.currentName, sub: r.submittedName },
                { label: "CCCD/Mã định danh", cur: r.currentCccd, sub: r.submittedCccd },
                { label: "Ngày sinh", cur: r.currentDob, sub: r.submittedDob },
              ];
              const open = expandedV === r.uid;
              return (
                <React.Fragment key={r.uid}>
                  <tr>
                    <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.submittedName}</td>
                    <td style={td}>{r.createdAt ? new Date(r.createdAt).toLocaleDateString("vi-VN") : ""}</td>
                    <td style={td}>
                      <button onClick={() => setExpandedV(open ? null : r.uid)} style={ghostBtn}>{open ? "▲ Ẩn" : "🔍 Xem lệch chỗ nào"}</button>{" "}
                      <button disabled={busy === r.uid} onClick={() => approveV(r.uid)} style={okBtn}>Duyệt</button>{" "}
                      <button disabled={busy === r.uid} onClick={() => rejectV(r.uid)} style={noBtn}>Từ chối</button>
                    </td>
                  </tr>
                  {open && (
                    <tr>
                      <td colSpan={3} style={{ padding: 0, border: "1px solid #e5e7eb" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, background: "#fafafa" }}>
                          <thead><tr>
                            <th style={{ ...th, textAlign: "left" }}>Trường thông tin</th>
                            <th style={th}>Hồ sơ đang lưu</th>
                            <th style={th}>Vừa nhập khi xác thực</th>
                          </tr></thead>
                          <tbody>
                            {fields.map((f) => {
                              const diff = String(f.cur || "").trim() !== String(f.sub || "").trim();
                              return (
                                <tr key={f.label}>
                                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{f.label}</td>
                                  <td style={{ ...td, background: diff ? "#fee2e2" : "transparent", color: diff ? "#991b1b" : "#374151" }}>{f.cur || <i style={{ color: "#9ca3af" }}>(trống)</i>}</td>
                                  <td style={{ ...td, background: diff ? "#fee2e2" : "transparent", fontWeight: diff ? 700 : 400, color: diff ? "#991b1b" : "#374151" }}>{f.sub || <i style={{ color: "#9ca3af" }}>(trống)</i>}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

const th = { border: "1px solid #e5e7eb", padding: "8px 10px", background: "#f9fafb", textAlign: "left", fontSize: 13 };
const td = { border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "center" };
const okBtn = { padding: "5px 12px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600 };
const ghostBtn = { padding: "5px 12px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 6, cursor: "pointer", fontWeight: 600 };
const noBtn = { padding: "5px 12px", background: "#fff", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 6, cursor: "pointer" };

export default HappySchoolJoinRequests;
